import { render, staticRenderFns } from "./skipList.vue?vue&type=template&id=ad84e0fc&scoped=true"
import script from "./skipList.vue?vue&type=script&lang=js"
export * from "./skipList.vue?vue&type=script&lang=js"
import style0 from "./skipList.vue?vue&type=style&index=0&id=ad84e0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad84e0fc",
  null
  
)

export default component.exports